"use client"

import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import { resultPostprocessing2 } from "@/components/fetcher/fetchInterceptor"
import { ShelfItemEntity } from "@/app/entities/ShelfEntity"
import { CommonSuccessResponse } from "@/app/api/(response)/CommonSuccessResponse"
import { getPromotionEventHeaders } from "@/app/components/PromotionEvent/utils/getPromotionEventHeaders"

const ROOT = process.env.NEXT_PUBLIC_ROOT

export type BookShelfBulkCreateRequest = {
  isbn: string[]
  shelfAnalyzeId: string
}

export type BookShelfBulkCreateResponse = CommonSuccessResponse<{
  items: ShelfItemEntity[]
}>

const fetchClientBookShelfBulkCreate = (request: BookShelfBulkCreateRequest) =>
  fetchInterceptorInClient(
    {
      method: "post",
      headers: getPromotionEventHeaders(),
    },
    ROOT,
  )(() => `/api/shelf/shelf-entries/bulk`, request).then(
    resultPostprocessing2<BookShelfBulkCreateResponse>,
  )

export default fetchClientBookShelfBulkCreate